import type {FC} from 'react';
import {
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  NumberField,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  Toolbar,
} from 'react-admin';

const ToolbarDeleteOnly: FC = (props) => (
  <Toolbar {...props}>
    <DeleteButton />
  </Toolbar>
);

export const InventoryStemEdit: FC = () => (
  <Edit>
    <SimpleForm toolbar={<ToolbarDeleteOnly />}>
      <ReferenceInput source="inventoryPlotUuid" reference="inventory-plots">
        <SelectInput optionText="code" validate={[required()]} />
      </ReferenceInput>
      <NumberInput source="diameterInMm" validate={[required()]} />
      <NumberInput source="height" validate={[required()]} />
      <NumberInput source="volumeUsc" />
      <NumberInput source="volumeIfn" />
    </SimpleForm>
  </Edit>
);

export const InventoryStemDatagrid: FC = () => (
  <Datagrid rowClick="edit">
    <NumberField source="diameterInMm" label="Diameter (mm)" />
    <NumberField source="height" />
    <NumberField source="volumeUsc" />
    <NumberField source="volumeIfn" />
    <EditButton />
    <DeleteButton />
  </Datagrid>
);
